import React, { useState } from 'react'; // Remove useEffect
import { useNavigate } from 'react-router-dom';
import { db } from '../../firebase/config'; // Ajusta la ruta si es necesario
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import NavBar from '../../components/NavBar/NavBar'; // Ajusta la ruta si es necesario
import './AddUserPage.css'; // Crea este archivo CSS para estilos

function AddUserPage() {
  const navigate = useNavigate();
  const [newUserForm, setNewUserForm] = useState({
    nombre: '',
    cecos: '',
    cedula: '',
    telefono: '',
    departamento: '',
    division: '',
    localidad: '',
    code_direccion: '',
    status_cliente: '1' // Default to active
  });
  const [addingUser, setAddingUser] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  // Opcional: Redirigir si el usuario no está autenticado (si es necesario)
  // useEffect(() => { // Keep this commented out or remove if not needed
  //   if (!auth.currentUser) {
  //     navigate('/login');
  //   }
  // }, [navigate]);

  const handleAddUserInputChange = (e) => {
    const { name, value } = e.target;
    setNewUserForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleAddNewUser = async (e) => {
    e.preventDefault();
    if (!newUserForm.nombre || !newUserForm.cecos) {
      setErrorMessage("Nombre y CECOS son campos obligatorios.");
      setSuccessMessage('');
      return;
    }

    try {
      setAddingUser(true);
      setSuccessMessage('');
      setErrorMessage('');

      const newUser = {
        nombre_cliente: newUserForm.nombre,
        cecos: newUserForm.cecos,
        cc_depart: newUserForm.cecos,
        cedula: newUserForm.cedula,
        telefono_cliente: newUserForm.telefono,
        departamento: newUserForm.departamento,
        division: newUserForm.division,
        localidad: newUserForm.localidad,
        direccion_cliente: newUserForm.localidad,
        code_direccion: newUserForm.code_direccion,
        status_cliente: newUserForm.status_cliente,
        creado_en: serverTimestamp(),
        actualizado_en: serverTimestamp()
      };

      const usuariosCollection = collection(db, 'levapan_usuarios');
      await addDoc(usuariosCollection, newUser);

      setSuccessMessage('¡Usuario de Levapán agregado con éxito!');
      setNewUserForm({ // Reset form after successful submission
        nombre: '',
        cecos: '',
        cedula: '',
        telefono: '',
        departamento: '',
        division: '',
        localidad: '',
        code_direccion: '',
        status_cliente: '1'
      });

      // Opcional: Redirigir al dashboard después de un tiempo
      setTimeout(() => {
        navigate('/dashboard');
      }, 2000);

    } catch (error) {
      console.error("Error al agregar usuario:", error);
      setErrorMessage("Ocurrió un error al agregar el usuario. Intenta nuevamente.");
      setSuccessMessage('');
    } finally {
      setAddingUser(false);
    }
  };

  return (
    <div className="add-user-page">
      <NavBar />
      <main className="add-user-content">
        <div className="add-user-form-container">
          <h2>Agregar Nuevo Usuario</h2>
          <p>Ingresa la información del nuevo usuario. Se guardará únicamente en la colección de Levapán.</p>

          {successMessage && (
            <div className="form-message success">
              <i className="fas fa-check-circle"></i> {successMessage}
            </div>
          )}
          {errorMessage && (
            <div className="form-message error">
              <i className="fas fa-exclamation-circle"></i> {errorMessage}
            </div>
          )}

          <form className="add-user-form" onSubmit={handleAddNewUser}>
            <div className="form-group">
              <label htmlFor="add-nombre">Nombre completo *</label>
              <input
                type="text"
                id="add-nombre"
                name="nombre"
                value={newUserForm.nombre}
                onChange={handleAddUserInputChange}
                placeholder="Nombre completo del usuario"
                required
                disabled={addingUser}
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="add-cecos">CECOS *</label>
                <input
                  type="text"
                  id="add-cecos"
                  name="cecos"
                  value={newUserForm.cecos}
                  onChange={handleAddUserInputChange}
                  placeholder="Código CECOS"
                  required
                  disabled={addingUser}
                />
              </div>
              <div className="form-group">
                <label htmlFor="add-cedula">Cédula</label>
                <input
                  type="text"
                  id="add-cedula"
                  name="cedula"
                  value={newUserForm.cedula}
                  onChange={handleAddUserInputChange}
                  placeholder="Número de cédula"
                  disabled={addingUser}
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="add-telefono">Teléfono</label>
              <input
                type="text"
                id="add-telefono"
                name="telefono"
                value={newUserForm.telefono}
                onChange={handleAddUserInputChange}
                placeholder="Número de teléfono"
                disabled={addingUser}
              />
            </div>

            <div className="form-group">
              <label htmlFor="add-departamento">Departamento</label>
              <input
                type="text"
                id="add-departamento"
                name="departamento"
                value={newUserForm.departamento}
                onChange={handleAddUserInputChange}
                placeholder="Departamento"
                disabled={addingUser}
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="add-division">División</label>
                <input
                  type="text"
                  id="add-division"
                  name="division"
                  value={newUserForm.division}
                  onChange={handleAddUserInputChange}
                  placeholder="División"
                  disabled={addingUser}
                />
              </div>
              <div className="form-group">
                <label htmlFor="add-localidad">Localidad</label>
                <input
                  type="text"
                  id="add-localidad"
                  name="localidad"
                  value={newUserForm.localidad}
                  onChange={handleAddUserInputChange}
                  placeholder="Localidad"
                  disabled={addingUser}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="add-code_direccion">Código Dirección</label>
                <input
                  type="text"
                  id="add-code_direccion"
                  name="code_direccion"
                  value={newUserForm.code_direccion}
                  onChange={handleAddUserInputChange}
                  placeholder="Código dirección"
                  disabled={addingUser}
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="add-status_cliente">Estado</label>
              <select
                id="add-status_cliente"
                name="status_cliente"
                value={newUserForm.status_cliente}
                onChange={handleAddUserInputChange}
                disabled={addingUser}
              >
                <option value="1">Activo</option>
                <option value="0">Inactivo</option>
              </select>
            </div>

            <div className="form-actions">
              <button
                type="submit"
                className="submit-btn"
                disabled={addingUser}
              >
                {addingUser ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i> Agregando...
                  </>
                ) : (
                  <>
                    <i className="fas fa-plus-circle"></i> Agregar Usuario
                  </>
                )}
              </button>
              <button
                type="button"
                className="cancel-btn"
                onClick={() => navigate('/dashboard')} // Vuelve al dashboard
                disabled={addingUser}
              >
                Cancelar
              </button>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
}

export default AddUserPage;
